// Import Packages

import React, { useEffect, useState } from "react";
import { Backdrop, MenuItem, Select, Tooltip } from "@material-ui/core";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import Parser from "html-react-parser";
import { Link } from 'react-router-dom';

// Import Material UI
import { AppBar, Box, Tab, Tabs } from "@material-ui/core/";
import Grid from "@material-ui/core/Grid";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Edit } from "@material-ui/icons";

// Import Pages
import LibraryService from "./../../../../services/LibraryService/LibraryService";
import { capitalizeFirstLetter, convertToDateFormat } from "../../../../helpers/helper";
import { alertState, personalizationState, licensePermission } from "../../../../recoil-store/recoil-state";
import Confirm from '../../../../components/DataTable/DeleteConfirm'
import Publish from "../../automs/publish/Publish";
import EditAction from "../EditAction/EditAction";

// Import Media Tools
import AddOnIcon from "../../../../assets/icons/add-on.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import ApplicationService from "../../../../services/ApplicationService/ApplicationService";
import ActionService from "../../../../services/ActionService/ActionService";
import LicenseService from "../../../../services/LicenseService/LicenseService";

// Import Helpers
import { createNewFlow } from '../../../../helpers/helper';

// Import Icons
import DeleteIcon from '../../../../assets/icons/actionIcons/delete-icon.svg'
import EditIcon from '../../../../assets/icons/actionIcons/edit-icon.svg';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    formControl: {
        marginRight: 10,
        minWidth: 288,
        height: 30,
    },
    accordion: {
        background: "#FAFAFA",
        marginBottom: 10,
        border: "0.5px solid #CFCFCF",
        boxSizing: "border-box",
        boxShadow: "none",
        borderRadius: 5,
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    selectEmpty: {
        marginLeft: theme.spacing(2),
        height: 30,
    },
    select: {
        height: 30,
    },
    customTabIndicator: {
        height: "3px",
        backgroundColor: "var(--black-pearl)",
        width: "5.5rem!important",
        marginLeft: "14%",
    },
}));

//override css material ui tabs
const TabStyle = withStyles((theme) => ({
    root: {
        fontSize: "12px",
        fontWeight: "700",
        textTransform: "none",
        "&:hover": {
            color: "var(--gravel) !important",
            opacity: 1,
        },
        "&$selected": {
            color: "var(--black-pearl)",
        },
    },
    selected: {},
}))((props) => <Tab {...props} />);

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div hidden={value !== index} {...other}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export default function LibraryDetail(props) {
    const history = useNavigate();
    const { t } = useTranslation();
    const personalization = useRecoilValue(personalizationState);
    const setAlert = useSetRecoilState(alertState);
    const license = useRecoilValue(licensePermission);
    const [customLibraryDevelopment, setCustomLibraryDevelopment] = useState(false);

    const label = 'CONTENT.LIBRARY.';
    const labelDetail = 'CONTENT.LIBRARIES.DETAIL.';
    const labelTrigger = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.TRIGGERS."
    const [loading, setLoading] = useState(false);
    const [version, setVersion] = useState({});
    const [refresh, setRefresh] = useState(false);
    const [isCustimizable, setIsCustimizable] = useState(false);

    const [devVersion, setDevVersion] = useState({});
    // const [activeVersion, setActiveVersion] = useState({});
    const [data, setData] = useState([]);
    const [versions, setVersions] = useState([]);
    const [actions, setActions] = useState([]);
    const [triggers, setTriggers] = useState([]);
    const [connections, setConnections] = useState([]);
    const classes = useStyles();
    // const [customColumn, setCustomColumn] = useState([]);
    // const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(0);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openConfirmForInstall, setOpenConfirmForInstall] = useState(false);
    const [resetAutomConfirm, setResetAutomConfirm] = useState({ status: false });
    const [deleteActionConfirm, setDeleteActionConfirm] = useState({ status: false });

    const [openPublish, setOpenPublish] = useState(false);
    const [libraryDetail, setLibraryDetail] = useState({});
    const [InstalledLibraryId, setInstalledLibraryId] = useState({});
    const [renameModal, setRenameModal] = useState({ open: false });
    let params = useParams();
    const search = useLocation().search;
    let environment_target = new URLSearchParams(search).get('t');
    const paramsId = params.id;

    let counter = 0;

    useEffect(() => {
        if (license.data.restricted_features && license.data.restricted_features.find(x => x === 'module.customlibrary.development')) {
            setCustomLibraryDevelopment(false);
        } else {
            setCustomLibraryDevelopment(true);
        }

        async function fetchData() {
            setLoading(true);

            environment_target = environment_target ? environment_target : "local";

            const response = await LibraryService.getLibraryVersionAction(
                paramsId,
                environment_target
            );
            if (response) {
                if (response.code === 404) {
                    history('/my-environment/libraries')
                }
                if (response.status && response.data.length) {
                    const rsp = await LicenseService.developmentCheck({ library_vendor: response.data[0].vendor });
                    if (rsp && rsp.status) {
                        setIsCustimizable(true);
                    } else {
                        setIsCustimizable(false);
                    }
                    setValue(0);
                    setData(response.data[0]);

                    // fetch app credentials
                    await fetchAppCredentials(response.data[0].application_id);

                    if (environment_target !== 'global') {
                        await handleVersionsData(response.data[0]);
                        await handleVersionsTriggerData(response.data[0].application);
                        setLoading(false);
                    } else {
                        // get installed library details
                        const result = await LibraryService.getLibraryVersions(response.data[0].library_label, "local");
                        let lv = [];
                        if (result.status && result.code === 200 && result.data.library_versions.length) {
                            setInstalledLibraryId(result.data.id);
                            lv = result.data.library_versions;
                        }
                        let libVersions = response.data[0].library_versions;
                        for (let i = 0; i < libVersions.length; i++) {
                            const v = libVersions[i];

                            // check library version installed
                            const selectVariable = lv.find(x => x.version === v.version);
                            if (selectVariable) {
                                libVersions[i].is_active = selectVariable.is_active;
                                libVersions[i].id = selectVariable.id;
                                libVersions[i].installed = true;
                            } else {
                                libVersions[i].is_active = false;
                                libVersions[i].installed = false;
                            }
                        }

                        response.data[0].library_versions = libVersions;
                        await handleVersionsData(response.data[0]);
                        await handleVersionsTriggerData(result.data.application);
                        setLoading(false);
                    }
                }
            }
        }

        fetchData().then(r => r);
    }, [paramsId, refresh]);

    function handleChange(e, newValue) {
        setValue(newValue);
    }

    useEffect(() => {
        if (versions && versions.length) {
            handleActiveDevVersions();
        }
    }, [versions]);

    async function fetchAppCredentials(application_id) {
        if (application_id) {
            // Fetch credentials of the application
            const credentialResponse = await ApplicationService.getAppCredentials({ application_id });
            if (credentialResponse) {
                setConnections(credentialResponse.data)
            }
        }
    }

    async function handleVersionsData(data) {
        if (data && data.library_versions?.length) {
            const libVersion = data.library_versions;
            setVersions(libVersion);

            if (data.is_system) {
                setActions(libVersion[libVersion.length - 1].actions)
            }
        }
    }

    async function handleVersionsTriggerData(data) {

        if (data && data.trigger_actions?.length) {
            const versionTriggers = data.trigger_actions;
            setTriggers(versionTriggers);
        }
    }

    function handleActiveDevVersions() {
        // Find developer version by checking is_published value from the library versions
        const dVersion = versions.find(item => !item.installed && !item.is_active && !item.is_published);

        if (dVersion) {
            setDevVersion(dVersion);
            setVersion(dVersion);
            setActions(dVersion.actions);
        }

        // Find active version by checking is_active value from the library versions
        const aVersion = versions.find(item => item.is_active);

        if (aVersion) {
            // setActiveVersion(aVersion);
            if (!dVersion) {
                setVersion(aVersion);
                setActions(aVersion.actions);
            }
        } else {
            setVersion(versions[versions.length - 1]);
            setActions(versions[versions.length - 1].actions);
        }
    }

    function handleActionData(data) {
        setActions(data);
    }

    async function handleActivate() {
        const data = {
            library_id: environment_target === 'global' ? InstalledLibraryId : paramsId,
            id: version.id,
        }

        const response = await LibraryService.upgradeLibrary(data);
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.LIBRARY." + response.message),
                severity: response.status ? 'success' : 'error'
            }));
            if (response.status) {
                let copyVersions = JSON.parse(JSON.stringify(versions))
                for (let i = 0; i < copyVersions.length; i++) {
                    copyVersions[i].is_active = copyVersions[i].id === version.id;
                }
                setVersions(copyVersions)
            }
        }
    }

    async function handleInstall() {
        const response = await LibraryService.downloadCustomLibrary(paramsId, { v_id: version.id });
        let message = ""
        if (data?.library_name === "4me") {
            message = "MESSAGES.LIBRARY.4ME-VALIDATION-ERROR"
        }
        if (response) {
            if (message) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(message),
                    severity: response.status ? 'success' : 'error',
                    link: "https://docs.autommate.com/userguide/release-notes/boston-edition/boston-4.3.0#xurrent-4me-update"
                }));
                setAlert(alert => ({
                    ...alert,
                    show: false,
                    link: ""
                }));
            }
            else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY." + response.message),
                    severity: response.status ? 'success' : 'error'
                }));
            }
            if (response.status) {
                let copyVersions = JSON.parse(JSON.stringify(versions))
                const i = copyVersions.findIndex(x => x.id === version.id);
                copyVersions[i].id = response.data.library_version_id;
                copyVersions[i].installed = true;
                setVersions(copyVersions);
                setInstalledLibraryId(response.data.library_id);
            }
        }
    }

    function handleCreateAction() {
        const actionTypeId = 'c45bede2-30e3-4b67-aa65-6e06621a9e05';
        createNewFlow(actionTypeId, history, t, setAlert);
        //history(`/action-new`);
    }

    async function handlePublish() {
        let libraryLabel = data.library_label;

        if (!libraryLabel) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.LIBRARY.PARAMETER-MISSING"),
                severity: 'error'
            }));
            return;
        }

        const response = await LibraryService.getLibraryVersion(
            libraryLabel,
            "global"
        );

        if (!response || !response.status) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: response.message ? t("MESSAGES.LIBRARY." + response.message) : "GENERAL.NETWORK-ERROR",
                severity: 'error'
            }));
        }
        let botDetails = undefined;
        let categories = [];
        let businessProcesses = [];
        let tags = "";
        if (response.data && response.data.library_versions) {
            botDetails = response.data?.library_versions[0]?.bot_library_versions[0]?.bot?.bot_details?.length ? response.data.library_versions[0].bot_library_versions[0].bot.bot_details[0] : undefined;
            categories = response.data?.library_versions[0]?.bot_library_versions[0]?.bot?.categories?.length ? [response.data.library_versions[0].bot_library_versions[0].bot.categories[0].id] : [];
            businessProcesses = response.data?.library_versions[0]?.bot_library_versions[0]?.bot?.business_processes?.length ? response.data.library_versions[0].bot_library_versions[0].bot.business_processes[0].id : [];
            tags = response.data?.library_versions[0]?.bot_library_versions[0]?.bot?.tags || "";
        }

        const libraryDetail = {
            type: "Library",
            library: {
                library_version: {
                    version: devVersion.version,
                    id: devVersion.id,
                    actions: devVersion.actions
                },
                bot_details: botDetails,
                categories,
                business_processes: businessProcesses,
                tags,
                library_label: data.library_label,
                library_name: data.library_name,
                vendor: data.vendor,
                id: data.id,
                image: data.image,
                application_id: data.application_id
            }
        }
        setLibraryDetail(libraryDetail);
        setOpenPublish(true);
    }

    const handleChangeVersion = function (item) {
        // const selectedVersion = versions.find(item => item.id === versionId);
        setVersion(item);
        setActions(item.actions);
    }

    const reRender = () => {
        setRefresh(!refresh);
    }

    const countTrigger = () => {
        return ++counter;
    }

    const getDefaultNameAndDescription = (action_name) => {
        const name = `${data.library_name.replace(/\s+/g, '')}_${action_name.replace(/\s+/g, '')}_${version.version}`
        const description = `This autom "${data.library_name}" library is created to display the "${action_name}" action version ${version.version} details.`;
        return {
            name,
            description
        }
    }

    const getThisAutom = async (e, index, actionDetail) => {
        e.stopPropagation();
        const a = getDefaultNameAndDescription(actionDetail.action_name);
        const input_data = {
            id: actionDetail.id,
            name: a.name,
            description: a.description,
            integration_type: "STANDARD",
            type_id: "c45bede2-30e3-4b67-aa65-6e06621a9e05", // action type
            version: version.version
        }
        const result = await ActionService.createAutomByAction(input_data);
        if (result) {
            if (result.status) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY.GET-AUTOM-SUCCESSFULLY"),
                    severity: 'success'
                }));
                let copyActions = [...actions];
                copyActions[index].c_library_version_actions[0].autom_version = { id: result.autom_version_id, autom_id: result.autom_id }
                setActions(copyActions);
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY." + result.message),
                    severity: 'error'
                }));
            }
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("GENERAL.NETWORK-ERROR"),
                severity: 'error'
            }));
        }
    }

    const resetAutom = async () => {

        const result = await ActionService.resetAutomByAction(resetAutomConfirm.input_data);
        if (result) {
            if (result.status) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY.RESET-AUTOM-SUCCESSFULLY"),
                    severity: 'success'
                }));
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY." + result.message),
                    severity: 'error'
                }));
            }
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("GENERAL.NETWORK-ERROR"),
                severity: 'error'
            }));
        }
    }

    const resetConfirm = (e, actionDetail) => {
        e.stopPropagation();
        const a = getDefaultNameAndDescription(actionDetail.action_name);

        setResetAutomConfirm({
            status: true,
            input_data: {
                id: actionDetail.id,
                name: a.name,
                description: a.description,
                autom_id: actionDetail.c_library_version_actions[0].autom_version.autom_id,
                autom_version_id: actionDetail.c_library_version_actions[0].autom_version.id
            }
        })
    }

    const deleteConfirm = (e, actionDetail) => {
        e.stopPropagation();
        setDeleteActionConfirm({
            status: true,
            id: actionDetail.id,
            name: actionDetail.action_name
        })
    }

    const renameModalOpen = (e, actionDetail) => {
        e.stopPropagation();
        setRenameModal({
            open: true,
            id: actionDetail.id,
            name: actionDetail.action_name
        })
    }


    const deleteAction = async () => {
        let index = -1;
        let copyVersions = [...versions];
        let selectedVersion = copyVersions.find(x => x.id === version.id);
        if (selectedVersion) {
            index = selectedVersion.actions.findIndex(x => x.id === deleteActionConfirm.id);
        }

        let copyActions = [...actions]
        const i = copyActions.findIndex(x => x.id === deleteActionConfirm.id);
        if (i === -1 || index === -1) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.LIBRARY.ACTION-NOT-FOUND"),
                severity: 'error'
            }));
        } else {
            const result = await ActionService.deleteAction(deleteActionConfirm.id);
            if (result) {
                if (result.status) {
                    selectedVersion.actions.splice(index, 1);
                    copyActions.splice(i, 1);
                    setVersions(copyVersions);
                    setActions(copyActions);
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t("MESSAGES.LIBRARY.ACTION-DELETED-SUCCESSFULLY"),
                        severity: 'success'
                    }));
                } else {
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t("MESSAGES.LIBRARY." + result.message),
                        severity: 'error'
                    }));
                }
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("GENERAL.NETWORK-ERROR"),
                    severity: 'error'
                }));
            }
        }
    }

    const onLoadRename = async (status, newName) => {
        if (status) {
            let index = -1;
            let copyVersions = [...versions];
            let selectedVersion = copyVersions.find(x => x.id === version.id);
            if (selectedVersion) {
                index = selectedVersion.actions.findIndex(x => x.id === renameModal.id);
            }

            let copyActions = [...actions]
            const i = copyActions.findIndex(x => x.id === renameModal.id);

            if (i === -1 || index === -1) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY.ACTION-NOT-FOUND"),
                    severity: 'error'
                }));
                return;
            }
            selectedVersion.actions[index].action_name = newName;
            copyActions[i].action_name = newName;
            setVersions(copyVersions);
            setActions(copyActions);
        }
        setRenameModal({ open: false })
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                {loading ? (
                    <Backdrop className={classes.backdrop} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                ) : (
                    <>
                        <Grid item xs={6}>
                            <div
                                className="libraries-header">{data?.library_label?.includes('CUSTOM') ? data?.library_name : t(`${label}${data?.library_name}.NAME`)}</div>
                            <div className="libraries-row">
                                <div className="libraries-col">
                                    <div
                                        className="libraries-header-title">{t("CONTENT.AUTOMS-LIST.LAST-MODIFIED")}</div>
                                    <div className="libraries-header-title-description">
                                        {version && (
                                            <div>
                                                {convertToDateFormat(version?.updated_at, personalization.date_format)}
                                            </div>
                                        )
                                        }
                                    </div>
                                </div>
                                <div className="libraries-col">
                                    <div className="libraries-header-title">{t("CONTENT.AUTOMS-LIST.MODIFIED-BY")}</div>
                                    <div className="libraries-header-title-description">
                                        {data.vendor}
                                    </div>
                                </div>

                                <div className="libraries-col">
                                    <div
                                        className="libraries-header-title">{t("CONTENT.AUTOMS-LIST.CURRENT-VERSION")}</div>
                                    <div className="libraries-header-title-description">
                                        {version.version}
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className="libraries-header-flex-end">
                                <FormControl className={classes.formControl}>
                                    <Select
                                        id="demo-simple-select-outlined"
                                        value={version}
                                        size="small"
                                        onChange={(e) => handleChangeVersion(e.target.value)}
                                        variant="outlined"
                                        displayEmpty
                                        inputProps={{ "aria-label": "Without label" }}
                                        style={{
                                            backgroundColor: "#FFFFFF",
                                            color: "#AFAFAF",
                                            height: 35,
                                        }}
                                    >
                                        {versions &&
                                            versions.map((item, index) =>
                                                item.is_active ? (
                                                    <MenuItem key={index} value={item}>
                                                        {`${item.version} (active)`}
                                                    </MenuItem>
                                                ) : item.id === devVersion?.id ? (
                                                    <MenuItem key={index} value={item}>
                                                        {`${item.version} (development)`}
                                                    </MenuItem>
                                                ) : (
                                                    <MenuItem key={index} value={item}>
                                                        {item.version}
                                                    </MenuItem>
                                                )
                                            )}
                                    </Select>
                                </FormControl>
                                {version && !version.is_active && !version.is_published && !version.installed ?
                                    customLibraryDevelopment && (
                                        <>
                                            <Button
                                                style={{ height: "30px !important" }}
                                                variant="contained"
                                                disabled={false}
                                                onClick={handlePublish}
                                                color="primary"
                                            >
                                                {t(labelDetail + "PUBLISH")}
                                            </Button>
                                            <Button
                                                style={{ height: "30px !important", marginLeft: 10 }}
                                                variant="contained"
                                                disabled={false}
                                                onClick={handleCreateAction}
                                                color="default"
                                            >
                                                {t(labelDetail + "CREATE-ACTION")}
                                                <Tooltip title={t("GENERAL.ADD-ON")} placement="top">
                                                    <img className="add-on-feature-button" src={AddOnIcon}
                                                        alt="add-on feature" />
                                                </Tooltip>
                                            </Button>
                                        </>
                                    ) : version.is_active && version.is_published ?
                                        (
                                            <Button
                                                style={{ height: "30px !important" }}
                                                variant="contained"
                                                disabled={true}
                                                onClick={(e) => {
                                                    return false;
                                                }}
                                            >
                                                {t(labelDetail + "ALREADY-ACTIVATED")}
                                            </Button>
                                        ) : version.is_published && !version.installed ? (
                                            <Button
                                                style={{ height: "30px !important" }}
                                                variant="contained"
                                                disabled={false}
                                                onClick={() => setOpenConfirmForInstall(true)}
                                                color="secondary"
                                            >
                                                {t(labelDetail + "GET-LIBRARY")}
                                            </Button>
                                        ) : <Button
                                            style={{ height: "30px !important" }}
                                            variant="contained"
                                            disabled={false}
                                            onClick={() => setOpenConfirm(true)}
                                            color="secondary"
                                        >
                                            {t(labelDetail + "ACTIVATE")}
                                        </Button>
                                }
                            </div>
                        </Grid>
                        {/*<Grid item xs={12}>*/}
                        {/*    <div>*/}
                        {/*        <div className="app-integration-title">{t("CONTENT.AUTOMS-LIST.AUTOM-DETAILS")}</div>*/}
                        {/*        <DataTable*/}
                        {/*            data={data?.library !== undefined ? [data?.library] : []}*/}
                        {/*            customColumns={customColumn}*/}
                        {/*            title="App Integration"*/}
                        {/*            loading={loading}*/}
                        {/*            pagination={false}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</Grid>*/}
                        <Grid item xs={12}>
                            <AppBar className="app-integration-appbar" position="static">
                                <Tabs
                                    variant="fullWidth"
                                    className="header-tabs"
                                    value={value}
                                    onChange={handleChange}
                                    classes={{
                                        indicator: classes.customTabIndicator,
                                    }}
                                    textColor="primary"
                                >
                                    <TabStyle index={0}
                                        label={`${t("CONTENT.AUTOMS-LIST.ACTIONS")}(${actions?.length ? actions.length : 0})`} />
                                    <TabStyle index={1} label={t("CONTENT.AUTOMS-LIST.TRIGGERS")} />
                                    <TabStyle index={2} label={t("CONTENT.AUTOMS-LIST.CONNECTIONS")} />
                                </Tabs>
                            </AppBar>
                        </Grid>
                        <Grid item xs={12}>
                            {value === 0 && actions ?
                                actions?.map((item, index) => (
                                    <Accordion className={classes.accordion} key={index}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon style={{ color: "#4A4A4A" }} />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <div className={`${classes.heading} accordion-bar-content`}>
                                                <div className="libraries-row">
                                                    <div className="app-integration-count">{index + 1}</div>
                                                    {
                                                        isCustimizable && item?.c_library_version_actions.length && environment_target === 'local' &&
                                                            devVersion.id === version.id ?
                                                            <>

                                                                <img src={DeleteIcon} alt="" className="delete-action-icon"
                                                                    onClick={(e) => deleteConfirm(e, item)} />

                                                                <img src={EditIcon} alt="" className="delete-action-icon"
                                                                    onClick={(e) => renameModalOpen(e, item)} />
                                                            </>

                                                            : undefined
                                                    }
                                                    <div className="app-integration-accordion-name">
                                                        {
                                                            item?.action_label?.toUpperCase().includes('CUSTOM') ? item?.action_name : t(`${label}${data?.library_name}.ACTION.${item?.action_name}`)
                                                        }
                                                    </div>
                                                </div>
                                                {
                                                    isCustimizable && item?.c_library_version_actions.length && environment_target === 'local' &&
                                                    <div>
                                                        {
                                                            !item.c_library_version_actions[0].autom_version ?
                                                                <Button
                                                                    className="download-button action-button-default m-r-30"
                                                                    variant="contained"
                                                                    onClick={(e) => getThisAutom(e, index, item)}
                                                                >
                                                                    {t(labelDetail + "GET-THIS-AUTOM")}
                                                                </Button>
                                                                : (
                                                                    <div className="items-center m-r-30" >
                                                                        <Button
                                                                            onClick={(e) => resetConfirm(e, item)}
                                                                            className="reset-button action-button-default m-r-30"
                                                                            variant="contained"
                                                                        >
                                                                            {t(labelDetail + "RETURN-THE-DEFAULT")}
                                                                        </Button>

                                                                        <Link className="height-23" onClick={(e) => e.stopPropagation()}
                                                                            to={`/automs/${item.c_library_version_actions[0].autom_version.autom_id}/autom/edit`}>
                                                                            <Edit className="height-23" />
                                                                        </Link>
                                                                    </div>
                                                                )
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails className="app-integration-accordion-line"
                                            style={{ paddingTop: "17px" }}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={6}>
                                                    <div style={{
                                                        backgroundColor: "#f5f3f3",
                                                        padding: "10px",
                                                        height: "100%"
                                                    }}>
                                                        <div style={{ width: "100%", color: "#0E1E30" }}>Description</div>
                                                        <div className="libraries-header-title-description">
                                                            <Typography>{Parser(item?.action_description ? item?.action_description : t(labelDetail + "NO-DESCRIPTION"))}</Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <div style={{
                                                        backgroundColor: "#f5f3f3",
                                                        padding: "10px",
                                                        height: "100%"
                                                    }}>
                                                        <div style={{ width: "100%", color: "#0E1E30" }}>Configuration
                                                        </div>
                                                        <div className="libraries-header-title-description">
                                                            <Typography>{Parser(item?.c_library_version_actions.length ? item?.c_library_version_actions[0].configuration : t(labelDetail + "NO-CONFIGURATION"))}</Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                )) : value === 1 && triggers ? (
                                    triggers?.map((item, index) => (
                                        item.trigger_modes.map((modeItem, modeIndex) => (
                                            <Accordion className={classes.accordion} key={modeIndex}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon style={{ color: "#4A4A4A" }} />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <div className={classes.heading}>
                                                        <div className="libraries-row">
                                                            <div
                                                                className="app-integration-count">{countTrigger()}</div>
                                                            <div className="app-integration-accordion-name">
                                                                {t(`${labelTrigger}${item?.name}`)} ({capitalizeFirstLetter(modeItem.type)})
                                                            </div>
                                                        </div>
                                                    </div>
                                                </AccordionSummary>

                                            </Accordion>
                                        ))
                                    ))) : value === 2 && connections && (
                                        connections?.map((item, index) => (
                                            <Accordion className={classes.accordion} key={index}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon style={{ color: "#4A4A4A" }} />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <div className={classes.heading}>
                                                        <div className="libraries-row">
                                                            <div
                                                                className="app-integration-count">{index + 1}</div>
                                                            <div className="app-integration-accordion-name">
                                                                {item.name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </AccordionSummary>

                                            </Accordion>
                                        ))
                                    )
                            }
                        </Grid>
                    </>
                )}
            </Grid>
            {
                openConfirm &&
                <Confirm setOpenDelete={setOpenConfirm} message={t('MESSAGES.LIBRARY.CHANGE-ACTIVE-LIBRARY')}
                    deleteFunc={handleActivate} />
            }
            {
                openConfirmForInstall &&
                <Confirm setOpenDelete={setOpenConfirmForInstall} message={t('MESSAGES.LIBRARY.GET-LIBRARY')}
                    deleteFunc={handleInstall} />
            }
            {
                openPublish && (
                    <Publish
                        reRender={reRender}
                        libraryDetail={libraryDetail}
                        automDetail={libraryDetail}
                        setOpenPublish={setOpenPublish}
                        triggers={triggers}
                    />
                )
            }
            {
                resetAutomConfirm?.status &&
                <Confirm setOpenDelete={() => setResetAutomConfirm({ status: false })} message={t('MESSAGES.LIBRARY.RESET-AUTOM-CONFIRM-MESSAGE')}
                    deleteFunc={resetAutom} />
            }
            {
                deleteActionConfirm?.status &&
                <Confirm setOpenDelete={() => setDeleteActionConfirm({ status: false })} message={`Are you sure you want to delete the "${deleteActionConfirm.name}" action?`}
                    deleteFunc={deleteAction} />
            }
            {
                renameModal.open &&
                <EditAction actionName={renameModal.name} id={renameModal.id} library_version_id={version.id} closeModal={onLoadRename} />
            }
        </div >
    );
}
